<template>
    <div class="main-content">
        <the-header title="Users"
                    :buttons="headerButtons"
                    v-on:button-create="$router.push({name: 'createUser', params: {page: 'base'}})"
        />
        <data-grid :settings="grid"
                   ref="dataGrid"
                   :storeDispatchList="listData"
                   :page="parseInt($route.params.page)"
                   v-on:button-delete="deleteItem($event)"
                   v-on:changePage="$router.push({name: 'users', params: {page: $event}})"
        >
            <template slot="fullName" slot-scope="data">
                <div class="mb-1">{{data.item.fullName}}</div>
                <small class="badge badge-secondary">{{t('Login count')}}: {{data.item.loginCount}}</small>
                <template v-if="data.item.parent === null">
                    <small class="badge badge-primary">{{t('Patients count')}}: {{data.item.patientCount}}</small>
                </template>
                <small class="badge badge-danger" v-if="data.item.testUser">{{t('Test user')}}</small>
            </template>
            <template slot="parent" slot-scope="data">
                <router-link v-if="data.item.parent !== null"
                             :to="{name: 'manageUserDetails', params: {id: data.item.parent.id}}"
                             class="link"
                >
                    {{data.item.parent.fullName}}
                </router-link>

            </template>
        </data-grid>
    </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import DataGrid from '../../../core/DataGrid/DataGrid'

    export default {
        components: {TheHeader, DataGrid},
        methods: {
            listData(params) {
                params.type = 'users';
                return this.$store.dispatch('users/list', params);
            },
            openItem(item) {
                this.$router.push({name: 'manageUser', params: {id: item.id, page: 'base'}});
            },
            deleteItem(item) {
                this.$store.dispatch('users/remove', item.id).then(() => {
                    this.$refs.dataGrid.fetchData();
                    this.$store.dispatch('alert/success', 'User was deleted')
                });
            }
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'button',
                        key: 'create',
                        name: this.t('Create user'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                        visible: () => {
                            return this.hasPermission('UserTitan', 'C');
                        }
                    }
                ],
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            to: (item) => {
                                return {
                                    name: 'manageUserDetails',
                                    params: {
                                        id: item.id,
                                    }
                                }
                            },
                            name: this.t('Edit'),
                            icon: 'eye',
                            styleClass: 'btn-primary btn-sm'
                        }, {
                            type: 'action',
                            key: 'delete',
                            name: this.t('Delete'),
                            icon: 'times',
                            styleClass: 'btn-danger btn-sm',
                            visible: () => {
                                return this.hasPermission('UserTitan', 'U');
                            }
                        }
                    ],
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Name'),
                            key: 'fullName',
                            sortField: ['firstname', 'lastname'],
                            filter: {
                                field: ['firstname', 'lastname'],
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        }, {
                            type: 'string',
                            name: this.t('Login'),
                            key: 'login',
                            filter: {
                                type: 'fulltext',
                            }
                        }, {
                            type: 'string',
                            name: this.t('Assigned to doctor'),
                            key: 'parent',
                            sortField: ['parent->firstname', 'parent->lastname'],
                            filter: {
                                field: ['parent->firstname', 'parent->lastname'],
                                type: 'fulltext',
                                likeType: '%_like_',
                            }
                        }, {
                            type: 'string',
                            name: this.t('Panel'),
                            key: 'panel.short',
                            sortField: ['panel->short'],
                            filter: {
                              type: 'select',
                              codeBook: 'panel',
                              valueLabel: 'short',
                              field: 'panel->id',
                            },
                        }
                    ]
                },
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/Users.vue